import { Component, Input, OnInit } from '@angular/core';
import { DateService } from 'src/app/services/date.service';
import { SignalingTypeEnum } from 'src/enumerators';

@Component({
  selector: 'app-popup-warranty-bar',
  templateUrl: './popup-warranty-bar.component.html',
  styleUrls: ['./popup-warranty-bar.component.css']
})


export class PopupWarrantyBarComponent implements OnInit {

  @Input() signaling;
  @Input() index = 0;
  dateText = '';
  warrantyBar = 0;
  active = 0;
  progress = 0;

  constructor(
    private _dateService: DateService,
  ) { }


  ngOnInit(): void {
    console.log(this.signaling)
    if (this.signaling.type == SignalingTypeEnum.Vertical) {
      this.dateText = this._dateService.getTextDate(this.signaling.trafficSigns[this.index]?.warrantyCurrent)
      this.active = this.signaling.trafficSigns[this.index]?.active;
      this.progress = this.signaling.trafficSigns[this.index]?.progress;
    } else {
      this.dateText = this._dateService.getTextDate(this.signaling?.warrantyCurrent)
      this.active = this.signaling.active;
      this.progress = this.signaling.progress;
    }
  }
}
